import { Loader } from 'google-maps';
// class Loader {};

const loader = new Loader('AIzaSyBxuPbWm7RzZUJdfatDK2qS4hmLQC1cJ0k');
const coordinates = { lat: 50.42622445158666, lng: 30.514884142500897 };
const popupContent = `
  <picture>
    <source srcset="./img/1x/map.webp 1x, ./img/2x/map@2x.webp 2x" type="image/webp" />
    <source srcset="./img/1x/map.jpg 1x, ./img/2x/map@2x.jpg 2x" type="image/jpeg" />
    <img src="./img/1x/map.jpg" alt="Location" class="map-img" />
  </picture>
  `;
const styles = [
  {
    "elementType": "geometry",
    "stylers": [
      {
        "color": "#f5f5f5"
      }
    ]
  },
  {
    "elementType": "labels.icon",
    "stylers": [
      {
        "visibility": "off"
      }
    ]
  },
  {
    "elementType": "labels.text.fill",
    "stylers": [
      {
        "color": "#616161"
      }
    ]
  },
  {
    "elementType": "labels.text.stroke",
    "stylers": [
      {
        "color": "#f5f5f5"
      }
    ]
  },
  {
    "featureType": "administrative.land_parcel",
    "elementType": "labels.text.fill",
    "stylers": [
      {
        "color": "#bdbdbd"
      }
    ]
  },
  {
    "featureType": "poi",
    "stylers": [
      {
        "visibility": "on"
      }
    ]
  },
  {
    "featureType": "poi",
    "elementType": "geometry",
    "stylers": [
      {
        "color": "#eeeeee"
      }
    ]
  },
  {
    "featureType": "poi",
    "elementType": "labels.icon",
    "stylers": [
      {
        "color": "#6b6b6b"
      },
      {
        "visibility": "on"
      }
    ]
  },
  {
    "featureType": "poi",
    "elementType": "labels.text.fill",
    "stylers": [
      {
        "color": "#6b6b6b"
      },
      {
        "visibility": "on"
      }
    ]
  },
  {
    "featureType": "poi",
    "elementType": "labels.text.stroke",
    "stylers": [
      {
        "color": "#ffffff"
      }
    ]
  },
  {
    "featureType": "poi.park",
    "elementType": "geometry",
    "stylers": [
      {
        "color": "#e5e5e5"
      }
    ]
  },
  {
    "featureType": "poi.park",
    "elementType": "labels.text.fill",
    "stylers": [
      {
        "color": "#9e9e9e"
      }
    ]
  },
  {
    "featureType": "road",
    "elementType": "geometry",
    "stylers": [
      {
        "color": "#ffffff"
      }
    ]
  },
  {
    "featureType": "road.arterial",
    "elementType": "labels.text.fill",
    "stylers": [
      {
        "color": "#757575"
      }
    ]
  },
  {
    "featureType": "road.highway",
    "elementType": "geometry",
    "stylers": [
      {
        "color": "#dadada"
      }
    ]
  },
  {
    "featureType": "road.highway",
    "elementType": "labels.text.fill",
    "stylers": [
      {
        "color": "#616161"
      }
    ]
  },
  {
    "featureType": "road.local",
    "elementType": "labels.text.fill",
    "stylers": [
      {
        "color": "#9e9e9e"
      }
    ]
  },
  {
    "featureType": "transit.line",
    "elementType": "geometry",
    "stylers": [
      {
        "color": "#e5e5e5"
      }
    ]
  },
  {
    "featureType": "transit.station",
    "stylers": [
      {
        "color": "#a5a5a5"
      },
      {
        "visibility": "on"
      }
    ]
  },
  {
    "featureType": "transit.station",
    "elementType": "geometry",
    "stylers": [
      {
        "color": "#eeeeee"
      }
    ]
  },
  {
    "featureType": "transit.station",
    "elementType": "labels.text.fill",
    "stylers": [
      {
        "color": "#6b6b6b"
      },
      {
        "visibility": "on"
      }
    ]
  },
  {
    "featureType": "transit.station",
    "elementType": "labels.text.stroke",
    "stylers": [
      {
        "color": "#ffffff"
      }
    ]
  },
  {
    "featureType": "water",
    "elementType": "geometry",
    "stylers": [
      {
        "color": "#c9c9c9"
      }
    ]
  },
  {
    "featureType": "water",
    "elementType": "labels.text.fill",
    "stylers": [
      {
        "color": "#9e9e9e"
      }
    ]
  }
]

loader.load().then(function (google) {
  const map = new google.maps.Map(document.getElementById('map'));
  const infoWindow = new google.maps.InfoWindow();
  const marker = new google.maps.Marker();
  const icon = {
    path: "M60 30C60 13.4708 46.5517 0 30 0C13.4483 0 0 13.4708 0 30C0 46.5517 13.4483 60 30 60C46.5517 60 60 46.5517 60 30ZM51.0045 30C51.0045 41.5817 41.5817 51.0045 30 51.0045C18.4183 51.0045 8.9955 41.5817 8.9955 30C8.9955 18.4183 18.4183 8.9955 30 8.9955C41.5817 8.9955 51.0045 18.4183 51.0045 30ZM42.7511 30C42.7511 37.039 37.039 42.7511 30 42.7511C22.961 42.7511 17.2489 37.039 17.2489 30C17.2489 22.961 22.961 17.2489 30 17.2489C37.039 17.2489 42.7511 22.961 42.7511 30Z",
    fillOpacity: 1,
    strokeWeight: 0,
    scale: 1,
    Origin: new google.maps.Point(0, 0),
    anchor: new google.maps.Point(0, 0),
    labelOrigin: new google.maps.Point(95, 28)
  }
  const icons = {
    iconDefault: Object.assign({ fillColor: '#333333' }, icon),
    iconHover: Object.assign({ fillColor: '#E9549C' }, icon),
  }

  map.setOptions({
    center: coordinates,
    zoom: 17,
    disableDefaultUI: true,
    styles,
  });

  marker.setOptions({
    position: coordinates,
    map,
    icon: icons.iconDefault,
    label: {
      text: 'MacPaw',
      color: "#737373",
      fontSize: "16px",
      fontFamily: "sans-serif",
      fontWeight: "400"
    }
  });

  infoWindow.setOptions({
    content: popupContent,
    pixelOffset: new google.maps.Size(0, 300)
  });

  // events
  google.maps.event.addListener(map, 'click', function () {
    infoWindow.close(map, marker);
  });
  google.maps.event.addListener(marker, 'click', function () {
    infoWindow.open(map, marker);
    infoWindow.setPosition(coordinates);
  });
  google.maps.event.addListener(marker, 'mouseover', function () {
    marker.setIcon(icons.iconHover);
  });
  google.maps.event.addListener(marker, 'mouseout', function () {
    marker.setIcon(icons.iconDefault);
  });
  // events
});
